module.exports = __webpack_public_path__ + "static/media/13.fb4269a4.jpg";